import axios from 'axios';

export default function sendMessage(values) {
  axios.post('https://api.qiydaarpratt.com/api/v1/messages', values).then((response)=>{
    console.log(values,response);
  });
};



// WEBPACK FOOTER //
// ./src/components/Contact/SendMessage.js